// client/src/hooks/useDisponibilidade.js
import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api'; 

export const useDisponibilidade = (params, options = {}) => {
    return useQuery({
        queryKey: ['disponibilidade', params],
        queryFn: async () => {
            try {
                // Filtra parâmetros vazios/nulos
                const filteredParams = Object.fromEntries(
                    Object.entries(params).filter(([_, v]) => v != null && v !== '')
                );

                console.log('Enviando requisição de disponibilidade com:', filteredParams);

                const { data } = await apiClient.get('/disponibilidade', { 
                    params: filteredParams 
                });

                if (!data.success) {
                    throw new Error(data.message || 'Erro ao buscar disponibilidade');
                }
                
                // Retorna diretamente o conteúdo útil
                return data.data;

            } catch (error) {
                console.error('Erro na requisição de disponibilidade:', error);
                throw new Error(error.response?.data?.error || 
                                error.message || 
                                'Não foi possível verificar a disponibilidade');
            }
        },
        enabled: !!options.enabled,
        retry: 1,
        staleTime: 1000 * 30 // 30 segundos
    });
};